import styled from 'styled-components'

export const Stamp = styled.div`
  background-image: url('/assets/img/stamps/video-chamada.svg');
  background-repeat: no-repeat;
  background-size: 100%;
  width: ${props => (props.daInfo ? '25px' : '16px')};
  height: ${props => (props.daInfo ? '49px' : '28px')};
`
